import { render, staticRenderFns } from "./EsqueceuSenha.vue?vue&type=template&id=6b5e7e75&"
import script from "./EsqueceuSenha.vue?vue&type=script&lang=js&"
export * from "./EsqueceuSenha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports